import I18n from "../../../../commons/I18n/I18n";
import ScreenCard from "../../../../components/screen/ScreenCard";
import { AppIcon } from "../../../../config/Config";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_PARKING_METERS } from "../../../../routing/Routes";
import ParkingMeterCardCompanyUser from "./ParkingMeterListCardCompanyUser";

const ParkingMeterListCompanyUserScreen = () => (
  <ScreenCard breadcrumbs={[
    {
      name: I18n.tr(I18nKeys.PARQUIMETROS),
      url: ROUTE_COMPANY_USER_PARKING_METERS,
      icon: AppIcon.PARKING_METER,
    },
  ]}>
    <ParkingMeterCardCompanyUser/>
  </ScreenCard>
);

export default ParkingMeterListCompanyUserScreen;
